// extracted by mini-css-extract-plugin
export default {"container":"_2eZ7s","logo":"_18g3E","logoImage":"_2LMUu","logoBackground":"_3cj5n","title":"_130N8","subtitle":"_2Qh7n","list":"_2vsJc"};